module.exports = __webpack_public_path__ + "347b46f5d4da9cc0b1fc6780a1ebf570.jpg";